import { getDocs, query, where } from "firebase/firestore";
import { getAnnualMaskRoleList } from "./annualMaskPurchaseUtils";

export const isAnnualMaskPhysician = (user) =>
  getAnnualMaskRoleList(user).includes("sleep_physician");

export const getAnnualMaskPhysicianConstraints = (user) => {
  const name = String((user && user.displayName) || "").trim();
  const email = String((user && user.email) || "").trim();
  return [
    ...(name ? [["doctorName", name]] : []),
    ...Array.from(new Set([email, email.toLowerCase()].filter(Boolean))).map((value) => ["doctorEmail", value]),
  ];
};

export const loadAnnualMaskCaseDocs = async (casesRef, user) => {
  if (!user) return [];
  if (!isAnnualMaskPhysician(user)) return (await getDocs(casesRef)).docs;
  // Separate equality queries work with existing single-field indexes, and
  // include older cases which saved only the doctor name or email.
  const snapshots = await Promise.all(
    getAnnualMaskPhysicianConstraints(user).map(([field, value]) =>
      getDocs(query(casesRef, where(field, "==", value))),
    ),
  );
  return Array.from(new Map(snapshots.flatMap((snapshot) => snapshot.docs).map((doc) => [doc.id, doc])).values());
};
